export const ReadiumWebpubContext =
  'https://readium.org/webpub-manifest/context.jsonld';
